import { BasicModel } from 'src/packages/mitsBasics';


/**
 * Temporäres Bild zur Übergagung ans Backend
 */
export class TemporaryImage implements BasicModel{
    id!: number;
    remote_id!:string;
    object_id!: number;
    description?: string;
    image!: File;
    created_at?: Date;
    updated_at?: string;

    /**
     * Constructor
     * @param {ITemporaryImageArgs} args 
     */
    constructor(args: ITemporaryImageArgs)
    {
        this.object_id = args.object_id;
        this.remote_id = args.remote_id;
        this.description = args.description;
        this.image = args.image;
        this.updated_at = new Date().toISOString();
    }
}


export interface ITemporaryImageArgs {
    remote_id:string;
    description: string;
    image: File;
    object_id: number;
}